import * as React from "react";
import clsx from "clsx";
import { GridContext } from "../grid/grid.mjs";
const GridColumn = (props) => {
  const { align, border, children, className, elementRef, id, noGutter, offset, order, width } = props;
  const { element: rootElement } = React.useContext(GridContext);
  let Element;
  switch (rootElement) {
    case "ol":
    case "ul":
      Element = "li";
      break;
    case "span":
      Element = "span";
      break;
    default:
      Element = "div";
  }
  const classNames = clsx(
    "grid__col",
    {
      "grid__col--no-vertical-gutter": !!noGutter
    },
    width ? width.map((i) => "grid__col--".concat(i)) : "grid__col--xs-12",
    offset == null ? void 0 : offset.map((i) => "grid__col--offset-".concat(i)),
    order == null ? void 0 : order.map((i) => "grid__col--".concat(i)),
    align == null ? void 0 : align.map((i) => "grid__col--".concat(i)),
    border == null ? void 0 : border.map((i) => "grid__col--border-".concat(i)),
    className
  );
  if (Element === "li") {
    return /* @__PURE__ */ React.createElement(Element, { id, className: classNames, "aria-hidden": props["aria-hidden"], ref: elementRef }, children);
  }
  return /* @__PURE__ */ React.createElement(Element, { id, className: classNames, "aria-hidden": props["aria-hidden"], ref: elementRef }, children);
};
export {
  GridColumn
};
